<template>
    <div class="m-messenger__wrapper w-100 m-messenger__wrapper--rating" style="bottom: 0px; position: absolute;"><i
            class="fa fa-times btn-closed delete-response" @click="closeFormFeedback()"></i>
        <div class="m-messenger__message m-messenger__message--in w-100 mb-0">
            <div class="m-messenger__message-body w-100">
                <div class="m-messenger__message-content text-center">
                    <div class="row">
                        <div class="col-md-12">
                            <h4 class="mb-0 text-bold-600 mb-0">{{config.title}}</h4>
                            <div class="rating mb-0" style="margin-bottom: 5px;">
                                <ul class="list">
                                    <li @click="rate(star)" v-for="star in max_stars"
                                        :class="{ 'active' : star <= current_star }" :key="star.stars" class="star">
                                        <i :class="star <= current_star ? 'fas fa-star' : 'far fa-star' "></i>
                                    </li>
                                </ul>
                            </div>
                            <textarea
                                :placeholder="config && config.follow_up && config.follow_up.placeholder ? config.follow_up.placeholder : $t('share_more_reviews')"
                                rows="6" class="form-control" id="recomend-content" v-model="recomend_content"></textarea>
                            <button class="btn btn-primary w-100 mt-1" v-if="current_star" @click="rating_submit()">{{$t('send')}}</button>
                            <button class="btn btn-primary w-100 mt-1" v-else style="cursor: not-allowed;">{{$t('send')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        props: [
            'config',
        ],
        data() {
            return {
                current_star: 0,
                max_stars: 5,
                recomend_content: '',
                message_id: ''

            }
        },
        created: function () {
        },
        mounted: function () {
            
        },
        methods: {
            rate(star) {
                if (typeof star === 'number' && star <= this.max_stars && star >= 0) {
                    this.current_star = star;
                }
            },
            rating_submit: function () {
                var $self = this;
                var data_rating = {
                    page_id: livechat.getId(),
                    rating_star: $self.current_star,
                    rating_recommend: $self.recomend_content,
                    message_id: $self.message_id,
                    question_id: $self.config.id,
                    sender_id: $self.st_token,
                    name: window.user.name,
                    windowInfo: livechat.windowInfo,
                    survey_data: {
                        name: window.user.name,
                        phone: window.user.phone,
                        email: window.user.email,
                        address: window.user.address
                    },
                    properties: window.user.properties
                };
                axios.post('/app/v1/public/RATING_NEW', data_rating)
                    .then((response) => {
                        $self.closeFormFeedback({
                            message_id: $self.message_id,
                            rating_star: $self.current_star,
                            rating_recommend: $self.recomend_content,
                        });
                    }).catch(error => {
                        console.log(error);
                    });
            },
            closeFormFeedback: function (dataEmit = []) {
                this.$emit('close-feedback-form', dataEmit)
            }
        },
        watch: {
            config: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    if (newValue && newValue.message_id) this.message_id = newValue.message_id;
                }
            },
        },
        computed: {
            st_token() {
                return this.$store.state.st_token;
            },
            lang() {
                return this.$store.state.lang;
            },
            page() {
                return this.$store.state.page;
            }
        },
    }
</script>
<style scoped lang="css">
    #rating-form {
        width: 90%;
        border: 1px solid #E8E8EB;
        padding: 0 18px 5px;
        margin: 0px 17px;
    }

    .m-timeline-1__item-body {
        margin-bottom: 1rem
    }

    fieldset {
        min-width: 0;
        padding: 0;
        margin: 0;
        border: 0;
    }

    .rating {
        display: flex;
        flex-direction: column;
        align-items: center;
        /* padding: 50px; */
        color: #b7b7b7;
        /* background: #fff; */
        border-radius: 8px;
        /* box-shadow: 0 6px 33px rgba(19, 18, 18, 0.09); */
    }

    .rating .list {
        padding: 0;
        margin: 0;
    }

    .rating .list .star {
        display: inline-block;
        font-size: 42px;
        transition: all .2s ease-in-out;
        cursor: pointer;
    }

    .rating .list .star.active {
        color: #ffe100;
    }

    .rating .list .star:first-child {
        margin-left: 0;
    }

    .rating .list:hover .star {
        color: #ffe100;
    }

    .rating .list .star:hover~.star:not(.active) {
        color: inherit;
    }

    .info {
        margin-top: 15px;
        font-size: 40px;
        text-align: center;
        display: table;
    }

    .info .divider {
        margin: 0 5px;
        font-size: 30px;
    }

    .info .score-max {
        font-size: 30px;
        vertical-align: sub;
    }

    fieldset .rating-text {
        word-break: inherit;
        margin-bottom: 20px;
        margin: 0 0 10px;
        line-height: 1.6;
    }

    fieldset .rating-text button#previous,
    fieldset .rating-text button#next {
        background: inherit;
    }

    fieldset .rating-text label {
        display: flex;
    }

    fieldset .rating-text textarea {
        margin-bottom: 5px;
    }

    fieldset {
        min-width: 0;
        padding: 0;
        margin: 0;
        border: 0;
    }

    .btn {
        display: inline-block;
        padding: 6px 12px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
    }

    .btn-sm,
    .btn-group-sm>.btn {
        padding: 5px 10px;
        font-size: 12px;
        line-height: 1.5;
        border-radius: 3px;
    }

    .pull-right {
        float: right;
    }

    .pull-left {
        float: left;
    }

    .btn-primary {
        color: #fff;
        background-color: #337ab7;
        border-color: #2e6da4;
    }

    .btn-secondary {
        color: #fff;
        background-color: #337ab7;
        border-color: #2e6da4;
    }

    .btn-secondary {
        color: #fff;
        background-color: #6c757d;
        border-color: #6c757d;
    }

    .form-control {
        display: block;
        width: 100%;
        height: 34px;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857143;
        color: #555;
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
        box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
        -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
        -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    }

    .text-center {
        text-align: center;
    }

    .text-bold-600 {
        font-weight: 600;
    }

    .mb-1 {
        margin-bottom: 1rem !important;
    }

    .rating {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #b7b7b7;
        border-radius: 8px;
    }

    .rating .list {
        padding: 0;
        margin: 0 20px 0 0;
    }

    .rating .list .star {
        display: inline-block;
        font-size: 30px;
        transition: all .2s ease-in-out;
        cursor: pointer;
    }

    .rating .list .star.active {
        color: #ffe100;
    }

    .rating .list .star:first-child {
        margin-left: 0;
    }

    .rating .list:hover .star {
        color: #ffe100;
    }

    .rating .list .star:hover~.star:not(.active) {
        color: inherit;
    }

    .btn-closed {
        position: absolute;
        right: -4px;
        top: -7px;
        background: #efe8e8;
        border-radius: 50%;
        padding: 3px 5px;
        color: #1E68C6;
        cursor: pointer;
        visibility: visible;
        opacity: 1;
        z-index: 100;
    }

    textarea.form-control {
        line-height: 1.6rem;
        font-size: 1rem;
        height: auto;
    }

    .m-messenger__wrapper--rating .m-messenger__message {
        display: table;
        table-layout: fixed;
    }

    .m-messenger__wrapper--rating .m-messenger__message .m-messenger__message-body {
        display: table-cell;
        vertical-align: top;
        padding: 0px;
        position: relative;
    }

    .m-messenger__wrapper--rating .row {
        display: flex;
        flex-wrap: wrap;
        margin-right: -14px;
        margin-left: -14px;
    }

    .m-messenger__wrapper--rating .col-md-12 {
        position: relative;
        width: 100%;
        padding-right: 14px;
        padding-left: 14px;
    }

    .m-messenger__wrapper--rating .m-messenger__message-content {
        margin-left: 10px;
        background: rgb(225, 229, 241);
        padding: 17px;
        margin-right: 5px;
        border-radius: 10px;
    }

    .w-100 {
        width: 100% !important;
    }

    .mt-1 {
        margin-top: 1rem !important;
    }
    #recomend-content{
        line-height: 1.2rem;
        font-size: 0.9rem;
    }
</style>